import { Box, Chip, TextField, Typography } from "@mui/material";
import Modal from "../Modals";
import { useContext, useEffect, useState } from "react";
import { NotificationContext } from "../../contexts/NotificationContext";
import styled from "styled-components";

type TSerialNumberSelectorModalProps = {
    selectedSerialNumbers: number[],
    availableSerialNumbers: number[],
    show: boolean,
    onClose: (selecetdSerialNumbers: number[]) => any,
    quantity: number,
    isStepCompleted? : boolean
}
type TSerialNumberSelectorProps = {
    selectedSerialNumbers: number[],
    availableSerialNumbers: number[],
    updateSerialNumbers: React.Dispatch<React.SetStateAction<number[]>>,
    quantity: number,
    isStepCompleted? : boolean,
    searchString: string
}
const SerialNumberSelectorModal = (props: TSerialNumberSelectorModalProps) => {
    const { availableSerialNumbers, onClose, selectedSerialNumbers, show, quantity, isStepCompleted } = props
    const [updatedSerialNumbers, setUpdatedSerialNumbers] = useState<number[]>(selectedSerialNumbers || [])
    const [searchString,setSearchString] = useState<string>("");

    useEffect(() => {
        if(show){
            setUpdatedSerialNumbers([...(selectedSerialNumbers || [])]);
        }
        else{
            setUpdatedSerialNumbers([]);
        }
    },[show]);

    return (
      <Modal
        open={show}
        maxWidth="md"
        title="Select Serial Numbers"
        onClose={() => {
            setSearchString("");
            onClose([...(updatedSerialNumbers || [])]);
        }}
      >
        <>
          <div style={{display:"flex", gap: 10}}>
          <StyledSearchField
            fullWidth
            size="small"
            variant="outlined"
            value={searchString}
            onChange={(event) => setSearchString(event.target.value)}
            label={'Search'}
            placeholder="Enter serial number to search"
            type={"number"}
          />
          <Typography>Selected Quantity: {`${updatedSerialNumbers.length || "0"}`}</Typography>
          </div>
          <SerialNumberSelector
            selectedSerialNumbers={selectedSerialNumbers}
            availableSerialNumbers={availableSerialNumbers}
            quantity={quantity}
            updateSerialNumbers={setUpdatedSerialNumbers}
            isStepCompleted={isStepCompleted}
            searchString={searchString}
          />
        </>
      </Modal>
    );
}

const SerialNumberSelector = (props: TSerialNumberSelectorProps) => {
    const { availableSerialNumbers, selectedSerialNumbers, quantity, updateSerialNumbers, isStepCompleted,searchString } = props
    
    const [filteredSerialNumbers, setFilteredSerialNumbers] = useState<number[]>(availableSerialNumbers || []);
    const [updatedSerialNumbers, setUpdatedSerialNumbers] = useState<number[]>(selectedSerialNumbers || [])
    const { notify } = useContext(NotificationContext)
    const [lastSelected, setLastSelected] = useState<number>(0);

    useEffect(() => {
        if(searchString){
            let filtered = availableSerialNumbers.filter(element => element.toString().includes(searchString));
            setFilteredSerialNumbers(filtered);
        }
        else{
            setFilteredSerialNumbers(availableSerialNumbers);
        }
        setLastSelected(0);
    }, [searchString]);

    const selectSerialNumberFun = (event: any, value: number) => {
        console.log("setAvailableSerialNumbers", event);
        const isSerialNumberAvailable = availableSerialNumbers.includes(value);
        console.log("setAvailableSerialNumbers1", isSerialNumberAvailable);
        let updatedSerialNumberArray: number[] = []
        if (value && isSerialNumberAvailable) {
            const isSerialNumberAlreadySelected = updatedSerialNumbers?.includes(value);
            if (event.shiftKey) {
                const serialNumberRange = filteredSerialNumbers.filter(serialNumber => {
                    console.log("shiftKey", serialNumber, lastSelected, serialNumber, value, serialNumber >= lastSelected && serialNumber <= value);
                    if (lastSelected > value) {
                        console.log("shiftKey", value, lastSelected);
                        return serialNumber <= lastSelected && serialNumber >= value
                    } else {
                        console.log("shiftKey", value, lastSelected);
                        return serialNumber >= lastSelected && serialNumber <= value
                    }
                })
                console.log(filteredSerialNumbers, serialNumberRange, "shiftKey");

                updatedSerialNumberArray = [...updatedSerialNumbers]
                for (let i = 0; i < serialNumberRange.length; i++) {
                    if (!updatedSerialNumberArray.includes(serialNumberRange[i])) {
                        updatedSerialNumberArray.push(serialNumberRange[i]);
                    }
                }
                console.log("shiftKey", updatedSerialNumberArray);
                if (updatedSerialNumberArray.length > quantity) {
                    return notify(`Serial Numbers can't be more than Quantity`, 'error');
                }
                console.log("isSerialNumberAlreadySelected3", updatedSerialNumberArray);
                setUpdatedSerialNumbers(updatedSerialNumberArray);
                updateSerialNumbers(updatedSerialNumberArray)

            } else if (isSerialNumberAlreadySelected) {

                updatedSerialNumberArray = updatedSerialNumbers.filter(serialNumber => serialNumber !== value)
                console.log("isSerialNumberAlreadySelected3", updatedSerialNumberArray);
                setUpdatedSerialNumbers(updatedSerialNumberArray);
                updateSerialNumbers(updatedSerialNumberArray)

                console.log("setAvailableSerialNumbers4", updatedSerialNumbers)
            } else {

                updatedSerialNumberArray = [...updatedSerialNumbers, value];
                if (updatedSerialNumberArray.length > quantity) {
                    return notify(`Serial Numbers can't be more than Quantity`, 'error');
                }
                setLastSelected(value);
                console.log("isSerialNumberAlreadySelected5", updatedSerialNumberArray);
                setUpdatedSerialNumbers(updatedSerialNumberArray);
                updateSerialNumbers(updatedSerialNumberArray)

                console.log("isSerialNumberAlreadySelected6", isSerialNumberAlreadySelected);
            }
        } else {
            notify(`Serial Number Doesn't Exist`, 'error');
        }

    }

    return <Box sx={{ display: "flex", gap: "10px", width: "700px", flexWrap: "wrap", justifyContent: "flex-start", cursor: "pointer" }}>
        {
            filteredSerialNumbers?.map((number: number) => {
                const isSerialNoSelected = updatedSerialNumbers?.includes(number);
                return <Chip key={number} onClick={(event) => selectSerialNumberFun(event, number)} sx={( isSerialNoSelected || isStepCompleted )? { flex: "1", backgroundColor: '#cfa04f', color: 'primary.contrastText' } : { '&:hover': { backgroundColor: '#cfa04f', color: 'primary.contrastText' }, flex: "1" }} label={number} />
            })
        }
    </Box>
}

const StyledSearchField = styled(TextField)`
    margin-bottom: 15px !important;
`

export default SerialNumberSelectorModal